<template>
  <el-card>
    <template #header>
      <h4>{{ $t('客户端中心') }}</h4>
    </template>

    <div class="client-content">
      <el-card shadow="never" v-for="(item, index) in rowData" :key="index">
        <template #header>
          <h4>{{ $t(item.name) }}</h4>
        </template>
        <div class="card-content">
          <span class="count">{{ data[item.allCountKey] || 0 }}</span>
          <ul>
            <li>{{ $t('IOS版数量') }} <span class="li-count">{{ data[item.iosCountKey] || 0 }}</span></li>
            <li>{{ $t('安卓版数量') }} <span class="li-count">{{ data[item.azCountKey] || 0 }}</span></li>
<!--            <li>鸿蒙版数量 <span class="li-count">{{ data[item.hmCountKey] || 0 }}</span></li>-->
          </ul>
        </div>
      </el-card>
    </div>
  </el-card>
</template>

<script>
export default {
  name: "ClientStat",
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      rowData: [
        {
          name: "今日装机次数",
          allCountKey: "todayAllCount",
          iosCountKey: "todayIosCount",
          azCountKey: "todayAzCount",
          hmCountKey: "todayHmCount"
        },
        {
          name: "当前APP装机次数",
          allCountKey: "nowApkAllCount",
          iosCountKey: "nowApkIosCount",
          azCountKey: "nowApkAzCount",
          hmCountKey: "nowApkHmCount"
        },
        {
          name: "APP总装机次数",
          allCountKey: "allCount",
          iosCountKey: "allIosCount",
          azCountKey: "allAzCount",
          hmCountKey: "allHmCount"
        },
      ]
    }
  }
}
</script>

<style scoped lang="scss">

.client-content {
  display: flex;
  justify-content: space-between;
  column-gap: 20px;

  .el-card {
    flex: 1;
  }
}

.card-content {
  display: flex;
  align-items: center;
  height: 180px;

  .count {
    flex: 2;
    text-align: center;
    font-weight: 600;
    font-size: 42px;
  }

  ul {
    flex: 1;
    list-style: none;

    li {
      line-height: 26px;

      .li-count {
        font-weight: 600;
      }
    }
  }

}

</style>
